import {Component, inject, OnInit} from '@angular/core';
import {
  BsHeaderComponent,
  DropdownButtonTriggerComponent,
  DropdownListComponent,
  DropdownListOptionComponent,
  EasytrackNotification,
  HeaderNavItemComponent,
} from 'bs-components';
import {NgxSpinnerService} from 'ngx-spinner';
import {AuthenticationService} from '../../core/services/authentication.service';
import {CurrentUserService} from '../../core/services/current-user.service';
import {LanguagesService} from '../../core/services/languages.service';
import {NotificationsService} from '../../core/services/notifications.service';
import {ThemeService} from '../../core/services/theme.service';

import {EnvironmentService} from '../../core/services/environment.service';
import {Environment} from '../../core/models/environment.model';
import {Router} from '@angular/router';
import {NotificationObject} from '../../core/models/notification-object.enum';
import {APP_ROUTE_ADMIN, APP_ROUTE_WORKFLOW} from '../../app-routing.module';
import {ADMIN_ROUTE_BINS} from '../../pages/admin/admin-bins/admin-bins.routes';
import {WORKFLOW_MY_TIRES_ROUTES} from '../../pages/workflow/workflow.routes';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [BsHeaderComponent, HeaderNavItemComponent, DropdownButtonTriggerComponent, DropdownListComponent, DropdownListOptionComponent],
})
export class HeaderComponent implements OnInit {
  private readonly themeService = inject(ThemeService);
  private readonly spinner = inject(NgxSpinnerService);
  private readonly router = inject(Router);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly languagesService = inject(LanguagesService);
  private readonly currentUserService = inject(CurrentUserService);
  private readonly environmentService = inject(EnvironmentService);
  private readonly notificationsService = inject(NotificationsService);

  public readonly isDarkTheme$ = this.themeService.isDark$;
  public readonly languages$ = this.languagesService.languages$;
  public readonly currentLanguage$ = this.languagesService.currentLanguage$;
  public readonly notifications$ = this.notificationsService.notifications$;
  public readonly currentUser$ = this.currentUserService.currentUser$;
  public readonly currentEnvironment = this.environmentService.currentEnvironment$;
  public readonly isMultiEnvironment = this.environmentService.isMultiEnvironment;

  ngOnInit(): void {
    this.notificationsService.getNotifications().subscribe();
  }

  toggleDarkTheme() {
    this.themeService.update().subscribe();
  }

  handleNotificationClick(notification: EasytrackNotification): void {
    this.notificationsService.readIfNot(notification)
      .subscribe(() => this.navigateToNotificationResource(notification));
  }

  languageChange(language: string) {
    this.languagesService.update(language).subscribe();
  }

  handleEnvironmentChange(environment: Environment) {
    this.environmentService.updateCurrentEnvironment(environment);
    this.router.navigateByUrl('/');
  }

  handleReadAllNotifications() {
    this.notificationsService.readAll().subscribe();
  }

  logout() {
    this.spinner.show().then();
    this.authenticationService.logout().then(() => {
      this.spinner.hide().then();
    });
  }

  private navigateToNotificationResource(notification: EasytrackNotification) {

    switch (notification.object) {
      case NotificationObject.BIN:
        this.router.navigate(['/', APP_ROUTE_ADMIN, ADMIN_ROUTE_BINS, notification.objectId]).then();
        return;
      case NotificationObject.TYRE:
        this.router.navigate(['/', APP_ROUTE_WORKFLOW, WORKFLOW_MY_TIRES_ROUTES, notification.objectId]).then();
        return;
    }
  }
}
